import { cn } from "@humanex/ui/libs";
import React from "react";

export interface SelectOption {
  value: string;
  label: string; // i18n key
}

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "children"> {
  label?: string;
  required?: boolean;
  labelClassName?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, label, labelClassName, required, error, options, placeholder, ...props }, ref) => {
    return (
      <div>
        {label && (
          <div className={cn("text-responsive-base font-medium text-slate-400 mb-1", labelClassName)}>
            {label} {required && <span className="text-error-500">(*)</span>}
          </div>
        )}
        <select
          required={required}
          className={cn(
            "h-10 w-full rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-normal text-ink",
            "disabled:opacity-40",
            error && "border-error-500",
            className
          )}
          ref={ref}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && <p className="text-xs text-error-500 mt-1">{error}</p>}
      </div>
    );
  }
);
